import React from 'react';
import { DayPicker, addToRange } from 'react-day-picker';
import { Button } from '@mui/material';
import 'react-day-picker/lib/style.css';

class DateRangeSelector extends React.Component {
  static defaultProps = {
    numberOfMonths: 1,
  };

  constructor(props) {
    super(props);
    this.state = {
      from: props.start,
      to: props.end,
    };
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleResetClick = this.handleResetClick.bind(this);
  }

  handleDayClick(day) {
    const range = addToRange(day, this.state);
    this.setState(range);
    this.props.onChange(range);
  }

  handleResetClick() {
    this.setState({ to: undefined, from: undefined });
  }

  render() {
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    return (
      <div className="RangeExample">
        <p>
          {!from && !to && 'Please select the first day.'}
          {from && !to && 'Please select the last day.'}
          {from
            && to
            && `Selected from ${from.toLocaleDateString()} to
                ${to.toLocaleDateString()}`}
          {' '}
          {from
            && to && (
            <Button className="link" onClick={this.handleResetClick}>
              Reset
            </Button>
          )}
        </p>
        <DayPicker
          className="Selectable"
          numberOfMonths={this.props.numberOfMonths}
          selectedDays={[from, { from, to }]}
          modifiers={modifiers}
          onDayClick={this.handleDayClick}
        />
      </div>
    );
  }
}

export default DateRangeSelector;
